export function isProductionDomain() {
  const currentDomain = window.location.hostname;
  return currentDomain === 'prod.noomo.org';
}

export function isStagingDomain() {
  const currentDomain = window.location.hostname;
  return currentDomain === 'stage.noomo.org';
}
